import { useEffect, useState } from "react";
import { http } from "../lib/api";

function fmt(v, kind) {
  if (kind === "índice") return v.toLocaleString("en-US", { maximumFractionDigits: 2 });
  if (kind === "tipo de cambio") return v.toFixed(4);
  return v.toFixed(2);
}

export default function StockTicker() {
  const [data, setData] = useState({ updated_at: null, quotes: [] });

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await http.get("/market");
        setData(data);
      } catch { /* ignore */ }
    };
    load();
    const id = setInterval(load, 60_000); // re-poll the cached endpoint every minute
    return () => clearInterval(id);
  }, []);

  if (!data.quotes?.length) {
    return (
      <div className="bg-ink text-paper border-y border-ink py-1.5 overflow-hidden" data-testid="stock-ticker">
        <div className="font-mono text-[11px] uppercase tracking-widest text-paper/50 px-4">
          Mercados · cargando…
        </div>
      </div>
    );
  }

  const list = [...data.quotes, ...data.quotes]; // duplicate for seamless scroll

  return (
    <div className="bg-ink text-paper border-y border-ink overflow-hidden" data-testid="stock-ticker">
      <div className="flex items-center">
        <span className="bg-rojo text-paper font-mono text-[10px] uppercase tracking-widest px-3 py-1.5 whitespace-nowrap shrink-0">
          BMV · BOLSA EN VIVO
        </span>
        <div className="flex-1 overflow-hidden">
          <div className="ticker-track flex items-center gap-8 py-1.5 whitespace-nowrap will-change-transform">
            {list.map((q, i) => {
              const up = q.change_pct >= 0;
              return (
                <span key={`${q.symbol}-${i}`} className="font-mono text-[12px] tracking-wide flex items-center gap-2">
                  <span className="font-semibold">{q.label}</span>
                  <span className="text-paper/70">{fmt(q.price, q.kind)}</span>
                  <span className={up ? "text-emerald-400" : "text-red-400"}>
                    {up ? "▲" : "▼"} {Math.abs(q.change_pct).toFixed(2)}%
                  </span>
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
